import { render, staticRenderFns } from "./comForm.vue?vue&type=template&id=e98f0992&scoped=true&"
import script from "./comForm.vue?vue&type=script&lang=ts&"
export * from "./comForm.vue?vue&type=script&lang=ts&"
import style0 from "./comForm.vue?vue&type=style&index=0&id=e98f0992&prod&lang=css&"
import style1 from "./comForm.vue?vue&type=style&index=1&id=e98f0992&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98f0992",
  null
  
)

export default component.exports